import { Link } from "react-router-dom";
import { RESTAURANT, LOGO } from "../lib/api";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#2E3628] bg-[#0F120E] mt-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Link to="/" className="inline-flex items-center gap-4" data-testid="footer-logo-link">
            <img
              src={LOGO.cream}
              alt="CHICA"
              className="h-14 md:h-16 w-auto object-contain"
              data-testid="footer-logo-img"
            />
            <span className="border-l border-[#2E3628] pl-4">
              <span className="font-display text-3xl tracking-[0.25em] text-[#F9F6F0] block leading-none">
                CHICA
              </span>
              <span className="overline mt-2 inline-block">Fine Dining · Lounge · Nightclub</span>
            </span>
          </Link>
          <p className="mt-8 text-[#9AA894] leading-relaxed text-sm max-w-md">
            Premium fine-dining, lounge and nightclub on Rajpur Road —
            North Indian, Italian, Asian and Continental cuisines under one
            Pinterest-worthy roof.
          </p>
          <div className="mt-8 inline-flex items-center gap-3 border border-[#2E3628] px-4 py-2.5">
            <span className="overline text-[10px] text-[#D4C1A0]">15% off</span>
            <span className="text-xs text-[#9AA894]">all dining via chica.com reservations</span>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-6">Visit</div>
          <p className="text-sm text-[#F9F6F0]/85 leading-relaxed">
            {RESTAURANT.address}
          </p>
          <p className="text-sm text-[#9AA894] mt-4">{RESTAURANT.hours}</p>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-6">Reach</div>
          <p className="text-sm text-[#F9F6F0]/85">{RESTAURANT.phone}</p>
          <p className="text-sm text-[#9AA894] mt-2">{RESTAURANT.email}</p>
          <a
            data-testid="footer-whatsapp"
            href={RESTAURANT.links.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-4 text-xs uppercase tracking-widest text-[#D4C1A0] hover:text-[#F9F6F0]"
          >
            WhatsApp →
          </a>
        </div>

        <div className="md:col-span-2">
          <div className="overline mb-6">Follow</div>
          <a
            href={RESTAURANT.links.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            aria-label="Instagram"
            className="inline-flex items-center gap-2 text-[#F9F6F0]/80 hover:text-[#D4C1A0] transition-colors"
          >
            <Instagram className="w-4 h-4" strokeWidth={1.2} />
            <span className="text-xs">@chicadoon</span>
          </a>

          <div className="mt-8 space-y-2">
            <a
              data-testid="footer-zomato"
              href={RESTAURANT.links.zomato}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-xs uppercase tracking-widest text-[#9AA894] hover:text-[#D4C1A0]"
            >
              Zomato →
            </a>
            <a
              data-testid="footer-swiggy"
              href={RESTAURANT.links.swiggy}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-xs uppercase tracking-widest text-[#9AA894] hover:text-[#D4C1A0]"
            >
              Swiggy →
            </a>
            <a
              data-testid="footer-eazydiner"
              href={RESTAURANT.links.eazydiner}
              target="_blank"
              rel="noopener noreferrer"
              className="block text-xs uppercase tracking-widest text-[#9AA894] hover:text-[#D4C1A0]"
            >
              EazyDiner →
            </a>
          </div>

          <Link
            to="/admin/login"
            data-testid="footer-admin-link"
            className="block mt-10 overline text-[10px] hover:text-[#D4C1A0]"
          >
            Staff Portal
          </Link>
        </div>
      </div>

      <div className="border-t border-[#2E3628]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between text-xs text-[#9AA894]">
          <p>© {new Date().getFullYear()} CHICA · Dehradun</p>
          <p className="tracking-widest uppercase mt-2 md:mt-0">Crafted with care</p>
        </div>
      </div>
    </footer>
  );
}
